import { render, staticRenderFns } from "./gsarea.vue?vue&type=template&id=54def656"
import script from "./gsarea.vue?vue&type=script&lang=js"
export * from "./gsarea.vue?vue&type=script&lang=js"
import style0 from "./gsarea.vue?vue&type=style&index=0&id=54def656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports